export default "__VITE_ASSET__DT815B5T__"